import { render, staticRenderFns } from "./MenuCascadeLayer.vue?vue&type=template&id=a654bc96"
import script from "./MenuCascadeLayer.vue?vue&type=script&lang=js"
export * from "./MenuCascadeLayer.vue?vue&type=script&lang=js"
import style0 from "./MenuCascadeLayer.vue?vue&type=style&index=0&id=a654bc96&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports